import React from 'react';
import {
  type Discount,
  type Subscription,
} from '@bbkPricingPage/types/pricing-table-types';

export type FunnelContextProps = Partial<{
  // whether we render yellow bars on top of the cards
  isDesigner: boolean;
  // void all onClicks in the Funnel, also used by pricing page editor/preview for context aware checkouts
  isPreview: boolean;
  isBrandingPage: boolean;
  isHostedPage: boolean;
  isPricingPage: boolean;
  funnelProps: {
    funnelId: `${number}` | number;
  };
  pricingPageProps: {
    pricingPageId: string;
    pricingPageEVId?: number;
    host?: string;
    pricingPageKey?: string;
    appId: string;
    siteId: string;
    bbkAuthenticityToken?: string;
    sessionId?: string;
    discounts?: Discount[];
    subscription?: Subscription;
    isDirty?: boolean;
    publishState?: 'draft' | 'live';
    defaultCurrency?: string;
  };
}>;

export const FunnelContext = React.createContext<FunnelContextProps>({});
